module.exports = __webpack_public_path__ + "img/csjl.fe2f5c9b.png";